import {useEffect} from 'react'
import {useAppActions} from '../../../hooks/runtime'

export const useCheckoutCacheListener = () => {
  const {navigateToDetails} = useAppActions()

  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        navigateToDetails()
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])
}
